export const pageIds = [
  '103148821737095',
  '100369412022827',
  '102587021794820'
];

export const adAccountIds = [
  '3596790690428125',
  '1270046590108161',
  '226116269145859'
];

export const productCatalogIds = [
  '455748045458188',
  '1656589767847792',
  '453230699021937'
];

export const pixels = [
  '406357910591555',
  '2785900558327134',
  '447274646453169'
];



// WEBPACK FOOTER //
// ./src/constants/nissan-united.js